@if (loader.visible()) {
  <div class="spinner-overlay">
    <div class="loader"></div>
    <div class="spinner-text-container">
      <h1 class="message-sp">{{ 'shared_label_wait_please' | translate }}</h1>
    </div>
  </div>
}
